import React, {useState} from "react";
import {useDispatch} from "react-redux";
import {css, cx} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {Rating} from "@pg-rp/rating";

import {addFailureNotification} from "../../../notifications/utils/add_failure_notification";
import {addSuccessNotification} from "../../../notifications/utils/add_success_notification";
import {postArticleRating} from "../../api/post_article_rating";
import {hitClickOnArticleRating} from "../../tracking/article_events";

interface IProps {
    articleId: number;
    ratings: {
        average: number | null;
        total: number;
    };
    isHorizontal?: boolean;
    className?: string;
}

export const ArticleRating: React.FC<IProps> = (props) => {
    const {
        articleId,
        isHorizontal,
        ratings: {average, total}
    } = props;

    const dispatch = useDispatch();
    const [currentRating, setCurrentRating] = useState(average);
    const [isReadOnly, setReadOnly] = useState(false);

    const onRatingChange = (value: number) => {
        postArticleRating({article: articleId, value})
            .then(() => {
                setCurrentRating(value);

                dispatch(addSuccessNotification("Ocena artykułu została dodana poprawnie"));
            })
            .catch((errors: string[]) => {
                if (errors.length) {
                    errors.forEach((content) => {
                        dispatch(addFailureNotification(content));
                    });
                } else {
                    dispatch(addFailureNotification("Coś poszło nie tak. Spróbuj ponownie później."));
                }
            })
            .finally(() => setReadOnly(true));
    };

    const onRatingClick = (value: number) => {
        onRatingChange(value);

        if (currentRating) {
            const type = currentRating === value ? "equal" : currentRating > value ? "down" : "top";

            hitClickOnArticleRating({article_id: articleId, type});
        }
    };

    return isHorizontal ? (
        <div className={cx(horizontalRatingWrapper, props.className)}>
            <Text color="var(--colors-gray-700)" className={ratingLabel} variant="info_txt_1">
                OCEŃ ARTYKUŁ:
            </Text>
            <Rating score={currentRating || 0} isReadOnly={isReadOnly} onClick={onRatingClick} />
        </div>
    ) : (
        <div className={cx(ratingContainer, props.className)}>
            {average !== null && !!total && (
                <div className={ratingWrapper}>
                    <Rating score={currentRating || 0} isReadOnly={isReadOnly} onClick={onRatingClick} />
                </div>
            )}
        </div>
    );
};

const ratingWrapper = css({
    display: "flex",
    justifyContent: "end"
});

const horizontalRatingWrapper = css({
    display: "flex",
    alignItems: "center"
});

const ratingContainer = css({
    textAlign: "right"
});

const ratingLabel = css({
    mr: 2
});
import React, {useState} from "react";
import {useDispatch} from "react-redux";
import {css, cx} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {Rating} from "@pg-rp/rating";

import {addFailureNotification} from "../../../notifications/utils/add_failure_notification";
import {addSuccessNotification} from "../../../notifications/utils/add_success_notification";
import {postArticleRating} from "../../api/post_article_rating";
import {hitClickOnArticleRating} from "../../tracking/article_events";

interface IProps {
    articleId: number;
    ratings: {
        average: number | null;
        total: number;
    };
    isHorizontal?: boolean;
    className?: string;
}

export const ArticleRating: React.FC<IProps> = (props) => {
    const {
        articleId,
        isHorizontal,
        ratings: {average, total}
    } = props;

    const dispatch = useDispatch();
    const [currentRating, setCurrentRating] = useState(average);
    const [isReadOnly, setReadOnly] = useState(false);

    const onRatingChange = (value: number) => {
        postArticleRating({article: articleId, value})
            .then(() => {
                setCurrentRating(value);

                dispatch(addSuccessNotification("Ocena artykułu została dodana poprawnie"));
            })
            .catch((errors: string[]) => {
                if (errors.length) {
                    errors.forEach((content) => {
                        dispatch(addFailureNotification(content));
                    });
                } else {
                    dispatch(addFailureNotification("Coś poszło nie tak. Spróbuj ponownie później."));
                }
            })
            .finally(() => setReadOnly(true));
    };

    const onRatingClick = (value: number) => {
        onRatingChange(value);

        if (currentRating) {
            const type = currentRating === value ? "equal" : currentRating > value ? "down" : "top";

            hitClickOnArticleRating({article_id: articleId, type});
        }
    };

    return isHorizontal ? (
        <div className={cx(horizontalRatingWrapper, props.className)}>
            <Text color="var(--colors-gray-700)" className={ratingLabel} variant="info_txt_1">
                OCEŃ ARTYKUŁ:
            </Text>
            <Rating score={currentRating || 0} isReadOnly={isReadOnly} onClick={onRatingClick} />
        </div>
    ) : (
        <div className={cx(ratingContainer, props.className)}>
            {average !== null && !!total && (
                <div className={ratingWrapper}>
                    <Rating score={currentRating || 0} isReadOnly={isReadOnly} onClick={onRatingClick} />
                </div>
            )}
        </div>
    );
};

const ratingWrapper = css({
    display: "flex",
    justifyContent: "end"
});

const horizontalRatingWrapper = css({
    display: "flex",
    alignItems: "center"
});

const ratingContainer = css({
    textAlign: "right"
});

const ratingLabel = css({
    mr: 2
});
